import { GUDHUB_SETTINGS } from './../../config.js';
require('../../core/localizationService/localizationService.js');

angular.module('mcpServersTableModule', ['localizationModule'])

    .service('McpServersService', [function () {
        const getAuthData = async function () {
            const token = await gudhub.getToken();
            const user = gudhub.storage.getUser();

            return {
                token,
                user_id: user.user_id,
                auth_key: user.auth_key
            };
        };

        const normalizeBaseUrl = function (url) {
            return String(url || '').trim().replace(/\/+$/, '');
        };

        const getMcpConnectorBaseUrl = function () {
            return normalizeBaseUrl(
                GUDHUB_SETTINGS.mcp_server_base_url ||
                GUDHUB_SETTINGS.node_services_api_path
            );
        };

        const buildMcpServerEndpoint = function (mcpServer, userId) {
            const baseUrl = getMcpConnectorBaseUrl();
            const normalizedUserId = String(userId || '').trim();
            const serverName = String(mcpServer?.mcp_server_name || '').trim();

            if (!baseUrl || !normalizedUserId || !serverName) {
                return '';
            }

            return [
                baseUrl,
                'api',
                'mcp',
                encodeURIComponent(normalizedUserId),
                encodeURIComponent(serverName)
            ].join('/');
        };

        const request = async function (url, data = {}) {
            const authData = await getAuthData();

            const response = await fetch(`${GUDHUB_SETTINGS.node_services_api_path}${url}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...data,
                    ...authData
                })
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'MCP server request error');
            }

            return result;
        };

        this.getMcpServerEndpoint = function (mcpServer) {
            const user = gudhub.storage.getUser();

            return buildMcpServerEndpoint(mcpServer, user?.user_id);
        };

        this.prepareMcpServerData = function (mcpServer) {
            const user = gudhub.storage.getUser();

            return {
                _id: mcpServer._id,
                old_mcp_server_name: mcpServer.old_mcp_server_name || mcpServer.mcp_server_name,
                mcp_server_name: mcpServer.mcp_server_name,
                active: !!mcpServer.active,
                app_with_functions: mcpServer.app_with_functions || null,
                field_id_with_functions: mcpServer.field_id_with_functions || null,
                items_with_functions: Array.isArray(mcpServer.items_with_functions)
                    ? mcpServer.items_with_functions
                    : [],
                mcp_server_endpoint: buildMcpServerEndpoint(mcpServer, user?.user_id)
            };
        };

        this.create = function (mcpServer) {
            return request('/mcp-servers-create', this.prepareMcpServerData(mcpServer));
        };

        this.update = function (mcpServer) {
            return request('/mcp-servers-update', this.prepareMcpServerData(mcpServer));
        };

        this.delete = function (mcpServer) {
            return request('/mcp-servers-delete', {
                mcp_server_name: mcpServer.mcp_server_name
            });
        };

        this.getList = function () {
            const user = gudhub.storage.getUser();

            return getAuthData().then(function (authData) {
                return fetch(
                    `${GUDHUB_SETTINGS.node_services_api_path}/mcp-servers-list?token=${encodeURIComponent(authData.token)}&user_id=${encodeURIComponent(user.user_id)}`
                ).then(r => r.json());
            });
        };

        this.getStatusLabel = function (active) {
            return active ? 'Enabled' : 'Disabled';
        };

        this.getStatusClass = function (active) {
            return active ? 'enabled' : 'disabled';
        };

        this.getTitleWidth = function (title) {
            const length = title ? title.length : 10;

            return length + 1 + 'ch';
        };
    }])

    .service('McpExternalFunctionsService', [function () {
        this.isExternalFunctionField = function (field) {
            if (!field) return false;

            return (
                field.data_type === 'external_function' ||
                field.data_type === 'ExternalFunction' ||
                field.data_type === 'externalFunction' ||
                field.data_type === 'external_function_field' ||
                field.data_model?.data_type === 'ExternalFunction' ||
                field.data_model?.external_function ||
                field.data_model?.externalFunction
            );
        };

        this.ensureExternalFunctionModel = function (field, mcpServer) {
            if (!field.data_model) {
                field.data_model = {};
            }

            if (!field.data_model.external_function) {
                field.data_model.external_function = {};
            }

            if (typeof field.data_model.external_function.active === 'undefined') {
                field.data_model.external_function.active = false;
            }

            if (mcpServer && mcpServer.mcp_server_name) {
                field.data_model.external_function.mcp_server_name = mcpServer.mcp_server_name;
            }

            return field;
        };

        this.prepareField = function (field, mcpServer) {
            field.icon = field.icon || 'automation_external_function';
            field.constructor = field.constructor || 'field';

            return this.ensureExternalFunctionModel(field, mcpServer);
        };

        this.getExternalFunctions = async function (mcpServer) {
            const apps = [];
            const appsWithFields = {};

            const appsList = await gudhub.getAppsList();

            const availableApps = appsList.filter(function (app) {
                return app.permission !== 4 && app.show !== false;
            });

            for (let i = 0; i < availableApps.length; i++) {
                const app = availableApps[i];

                try {
                    const application = await gudhub.getApp(app.app_id);
                    const fieldList = application.field_list || [];

                    const externalFunctionFields = fieldList
                        .filter(this.isExternalFunctionField)
                        .map(field => this.prepareField(field, mcpServer));

                    if (externalFunctionFields.length) {
                        app.externalFunctionsOpened = false;

                        apps.push(app);
                        appsWithFields[app.app_id] = externalFunctionFields;
                    }
                } catch (error) {
                    console.log('MCP External Functions app error:', app.app_id, error);
                }
            }

            return {
                apps,
                appsWithFields
            };
        };

        this.updateField = function (appId, field) {
            return gudhub.updateField(appId, field);
        };
    }]);